import React from "react";

const ActivityFooter = ({ onBack, onContinue, color, isFinal }) => {
  return (
    <footer className="footer px-15 pb-30 pt-50 flex justify-between mx-auto w-full mb-50">
      {onBack && (
        <button
          onClick={onBack}
          className={`previous font-secondary text-${color} hover:text-gray-800 uppercase font-bold relative pl-30 pt-4 focus:outline-none`}
        >
          <span className="icon-prev absolute v-middle l-0 text-22"></span> back
        </button>
      )}
      {onContinue ? (
        <button
          onClick={onContinue}
          className={`next font-secondary text-${color} hover:text-gray-800 uppercase font-bold relative pr-30 pt-4 focus:outline-none`}
        >
          <span className="icon-next absolute v-middle r-0 text-22"></span>
          {isFinal ? "NEXT LESSON" : "CONTINUE"}
        </button>
      ) : (
        <button
          disabled={true}
          className={`next font-secondary text-gray-100 uppercase font-bold relative pr-30 pt-4 cursor-not-allowed focus:outline-none`}
        >
          <span className="icon-next absolute v-middle r-0 text-22"></span>
          {isFinal ? "NEXT LESSON" : "CONTINUE"}
        </button>
      )}
    </footer>
  );
};

export default ActivityFooter;
